import React, { useContext, useState, useEffect } from 'react';
import { LocalizationContext } from '../../../contexts';
import './index.scss';

const ImageUploader = ({ imageUrl, onChange, prefix, type }) => {
    const [localization] = useContext(LocalizationContext);
    const [isDragging, setIsDragging] = useState(false);
    const [error, setError] = useState(false);
    const [timer, setTimer] = useState(false);

    const supportedFiles = {
        "image": {
            fileType: ["image/gif", "image/jpg", "image/jpeg", "image/png"],
            accept: ".jpeg, .jpg, .png, .gif",
            hint: "hint"
        },
        "seo_image": {
            fileType: ["image/jpg", "image/jpeg", "image/png"],
            accept: ".jpeg, .jpg, .png",
            hint: "seo_hint"
        }
    };
    
    useEffect(() => {
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);

    const showError = (errorMas) => {
        setError(errorMas);
        setTimer(setTimeout(() => {
            setTimer(false);
            setError(false);
        }, 2000));
    };

    const isDraggingOn = () => {
        setIsDragging(true);
    };
    const isDraggingOff = () => {
        setIsDragging(false);
    };

    const uploadFile = (files) => {
        if (!files || files.length !== 1) {
            showError(localization.labels.thumbnailUploader.select_one_image);
            return;
        }

        var file = files[0];
        var fileSize = file.size ? file.size : 0;
        var fileType = file.type ? file.type.toLowerCase() : "";
        if (fileSize > 5 * 1024 * 1024) { // 5MB
            showError(localization.labels.thumbnailUploader.max_file_size);
            return;
        }
        if (supportedFiles[type].fileType.indexOf(fileType) < 0) {
            showError(localization.labels.thumbnailUploader.unsupported_file_format);
            return;
        }

        window.cet.microservices.nairobiapi.fileUpload.upload({
          container: 'uploads',
          prefix: prefix + '/images',
          file: file
      }).then(url => {
        onChange(url);
      });
    };

    const removeFile=(e) =>{
      e.stopPropagation();
      onChange("");
    }

    return (
        <div className="app-uploader app-uploader--image">
          <div className="app-uploader--image-dropzone"
                    data-isdragging={isDragging ? 1 : 0}
                    onDragEnter={isDraggingOn}
                    onDragOver={isDraggingOn}
                    onDragLeave={isDraggingOff} onDrop={(e) => {
                        isDraggingOff();
                        uploadFile(e.dataTransfer.files);
                    }}
                    onClick={() => {
                        var inputFile = document.createElement("input");
                        inputFile.type = "file";
                        inputFile.accept = supportedFiles[type].accept;
                        inputFile.onchange = function (e) {
                            uploadFile(e.target.files);
                        };
                        inputFile.click();
                    }}
                >
                 <div className="app-uploader--image-drag">
                    {!error && <span><div className="k-icon k-i-upload"></div>{localization.labels.thumbnailUploader.choose_image}</span>}
                 </div>
                <div className="app-uploader--image-error">{error && <span><div className="k-icon k-i-exception"></div>{error}</span>}</div>
                {imageUrl && <button className="app-uploader--image-delete k-icon k-i-delete" onClick={(e)=>{removeFile(e)}}></button>}
            </div>
          {imageUrl && <img className="app-uploader--image-preview" src={imageUrl} alt=""/>}
          <div className="k-form-hint k-text-start">{localization.labels.imageUploader[supportedFiles[type].hint]}</div>
        </div>
    );
};

export default ImageUploader;